export default {

    methods: {

        formIdForLocation(locationId) {
            const defaultForm = this.project.forms.find(f => f.is_default);
            if (!locationId) {
                return defaultForm ? defaultForm.id : null;
            }
            const location = this.project.locations.find(l => parseInt(l.id) === parseInt(locationId));
            return location && location.form_id ? location.form_id : (defaultForm ? defaultForm.id : null);
        },

        setLocationId(locationId) {
            this.$set(this.params, 'location_id', locationId);
            this.$set(this.params, 'form_id', this.formIdForLocation(locationId));
        },

        syncFormForLocation(locationId) {
            this.$set(this.params, 'form_id', this.formIdForLocation(locationId));
        },

    },

};
